import { Toast as toast, Dialog } from 'vant';

const dialog = {
    toast
};

const icons = { error: '操作失败', success: '操作成功' };
Object.keys(icons).reduce((dialog, key) => {
    dialog[key] = (mes, obj = {}) => {
        return new Promise(function(resolve) {
            mes = typeof mes == 'object' ? mes.msg || mes : mes;
            toast({
                message: mes || icons[key],
                duration: 1000,
                icon: key == 'error' ? 'fail' : 'success',
                onClose: () => {
                    resolve();
                },
                ...obj
            });
        });
    };
    return dialog;
}, dialog);

dialog.message = (mes = '操作失败', obj = {}) => {
    return new Promise(function(resolve) {
        mes = typeof mes == 'object' ? mes.msg || mes : mes;
        toast({
            message: mes,
            duration: 1000,
            onClose: () => {
                resolve();
            },
            ...obj
        });
    });
};
dialog.loading = (mes = '加载中...', click = false, duration = 0) => {
    return new Promise(function() {
        mes = typeof mes == 'object' ? mes.msg || mes : mes;
        toast.loading({
            message: mes,
            forbidClick: click,
            duration: duration,
            overlay: true
        });
    });
};
dialog.close = () => {
    return new Promise(function(resolve) {
        toast.clear();
        setTimeout(() => {
            resolve();
        }, 100);
    });
};

dialog.validateError = (...args) => {
    validatorDefaultCatch(...args);
};

dialog.alert = (mes = '操作成功', obj = {}) => {
    return new Promise(function(resolve) {
        Dialog.alert({ message: mes, ...obj }).then(() => {
            resolve();
        });
    });
};
dialog.confirm = (mes = '操作成功', obj = {}) => {
    return new Promise(function(resolve, reject) {
        Dialog.confirm({ message: mes, ...obj })
            .then(() => {
                resolve();
            })
            .catch(() => {
                // on cancel
                reject();
            });
    });
};

export function validatorDefaultCatch(err, type = 'message') {
    return dialog[type](err.errors[0].message);
}

export default dialog;
